import _ from 'lodash';
import types from 'frontend/state/actionTypes';

import gearsetReducer, { gearsetDefaultName } from './gearset';

const initialState = [];

const gearsetsReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case types.ADD_GEARSET: {
      const { gearset } = payload;
      if (!_.isEmpty(gearset)) {
        return [
          ...state,
          {
            ...gearset,
            id: payload.gearsetId,
          },
        ];
      }

      return [
        ...state,
        gearsetReducer(undefined, action),
      ];
    }
    case types.REMOVE_GEARSET:
      return _.reject(state, { id: payload });
    case types.DUPLICATE_GEARSET: {
      const duplicatedGearset = _.cloneDeep(_.find(state, { id: payload.gearsetId }));
      duplicatedGearset.id = payload.newGearsetId;
      duplicatedGearset.name = '';
      return [
        ...state,
        duplicatedGearset,
      ];
    }
    case types.LOAD_GEAR_REPORT:
      return payload.meta.rawFormData.gearsets;
    case types.REMOVE_ITEM:
    case types.ADD_ITEM:
    case types.INPUT_GEARSET_NAME:
    case types.INPUT_ITEM:
    case types.INPUT_ITEM_SLOT:
    case types.INPUT_ITEM_LEVEL:
    case types.INPUT_ITEM_GEM:
    case types.INPUT_ITEM_GEM_LEVEL:
    case types.INPUT_ITEM_ENCHANT:
    case types.INPUT_ITEM_SECONDARY:
    case types.INPUT_ITEM_AFFIX:
    case types.INPUT_ITEM_HAND:
    case types.INPUT_ITEM_AZERITE_POWER:
    case types.INPUT_ITEM_LEGENDARY_POWER:
    case types.INPUT_ITEM_LEGENDARY_STATS:
    case types.INPUT_ITEM_CRAFTED_STATS:
    case types.INPUT_ITEM_EMBELLISHMENT:
      return state.map((gearset) => {
        if (gearset.id === payload.gearsetId) {
          return gearsetReducer(gearset, action);
        }
        return gearset;
      });
    case types.SUBMIT_SIM_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default gearsetsReducer;

const gearsetsSelector = state => state.simbot.gearsets;

export const selectors = {
  gearsets: state => _.map(gearsetsSelector(state), gearset => ({
    ...gearset,
    defaultName: gearsetDefaultName(gearset),
  })),
};
